export function parseKMLAndGetCoordinates(kmlContent: string): [number, number, number][] {
    const parser = new DOMParser();
    // Parse the KML content into an XML document
    const xmlDoc = parser.parseFromString(kmlContent, "application/xml");
    const coordinates = xmlDoc.getElementsByTagName("coordinates");

    let coordPairs: [number, number, number][] = [];

    for (let i = 0; i < coordinates.length; i++) {
        // Split the coordinates content by whitespace and/or commas to separate out each pair
        const coords = coordinates[i].textContent?.trim().split(/\s+/) || [];

        coordPairs = coordPairs.concat(coords.map(coord => {
            const parts = coord.split(",");
            const longitude = parseFloat(parts[0]);
            const latitude = parseFloat(parts[1]);
            const elevation = parts[2] ? parseFloat(parts[2]) : 0; // Default to 0 if no elevation
            return [longitude, latitude, elevation];
        }));
    }

    return coordPairs;
}

export function generateKML(coordinates: [number, number, number][]): string {
    const kmlHeader = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
<Document>
    <Placemark>
        <LineString>
            <coordinates>`;

    const kmlFooter = `</coordinates>
        </LineString>
    </Placemark>
</Document>
</kml>`;

    // Convert coordinates to KML format: "longitude,latitude,elevation longitude,latitude,elevation ..."
    const kmlCoordinates = coordinates.map(coord => {
        const [longitude, latitude, elevation] = coord;
        return `${longitude},${latitude},${elevation || 0}`;
    }).join(' ');

    return kmlHeader + kmlCoordinates + kmlFooter;
}


